import LinkEnhance from '@/component/LinkEnhance'
import Loading from '@/component/Loading'
import { TGASDK } from '@kulee/tga-sdk'
import type { Game } from '@kulee/tga-sdk/types/types/game'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import SearchGameItem from '../SearchGameItem'

// TODO： PC中键盘上下键监听，移动结果选择
const SearchResult: React.FC<PropType> = ({ keyword }) => {
  const { t } = useTranslation()
  const [games, setGames] = useState<Game[]>()

  const search = async () => {
    if (!keyword) {
      return
    }

    const { data } = await TGASDK.module.Game.service.searchGameList(keyword)

    setGames(data)
  }

  useEffect(() => {
    setGames(undefined)
    search()
  }, [keyword])

  if (!games) {
    return <Loading className="h-40" />
  }

  return (
    <div className="h-full py-sm">
      <div className="max-h-[calc(100%-3.5rem)] overflow-hidden sm:max-h-96 sm:overflow-y-auto">
        {games.map(game => {
          return <SearchGameItem key={game.code} game={game} />
        })}
      </div>
      <div className="h-10 text-center leading-10">
        <LinkEnhance className="text-base text-primary-text" href={`/search?keyword=${keyword}`}>
          {t('btn.searchAll')}
        </LinkEnhance>
      </div>
    </div>
  )
}

interface PropType {
  keyword?: string
}

export default SearchResult
